import { FieldPath, UseFormReturn } from 'react-hook-form';
import { ToggleField } from '@brighte/form-components';
import { HouseholdType } from '@brighte/validation';
import { RepaymentInput } from '@components/RepaymentInput';
import { Field } from '@spark-web/field';
import { Stack } from '@spark-web/stack';
import { HOUSEHOLD } from '@utils';

type Props = Pick<UseFormReturn<HouseholdType>, 'watch' | 'control' | 'setValue'>;

function CreditCard({ control, watch, setValue }: Props) {
  const { CREDIT_CARDS_LABEL, CREDIT_CARDS_DESCRIPTION, CREDIT_CARDS_AMOUNT_HEADER } = HOUSEHOLD;
  const CREDIT_CARD_FIELD = 'applicant.expense.creditCards' as FieldPath<HouseholdType>;

  const isCreditCardsNotApplicable = watch(`${CREDIT_CARD_FIELD}.isNotApplicable` as FieldPath<HouseholdType>);

  const handleCreditCardsToggle = (value: boolean) => {
    // value is isNotApplicable: true = "No" (not applicable), false = "Yes" (has credit cards)
    if (value) {
      setValue(`${CREDIT_CARD_FIELD}.limit` as FieldPath<HouseholdType>, undefined as never);
    }
  };

  return (
    <Stack gap="xlarge">
      <ToggleField
        name={`${CREDIT_CARD_FIELD}.isNotApplicable` as FieldPath<HouseholdType>}
        label={CREDIT_CARDS_LABEL}
        control={control}
        layout="inline"
        onChange={handleCreditCardsToggle}
        isInvertedValue
      />
      {!isCreditCardsNotApplicable && isCreditCardsNotApplicable !== undefined && (
        <Field label={CREDIT_CARDS_AMOUNT_HEADER} description={CREDIT_CARDS_DESCRIPTION}>
          <RepaymentInput
            period="monthly"
            endLabel="spending limit"
            name={`${CREDIT_CARD_FIELD}.limit`}
            control={control}
            label=""
          />
        </Field>
      )}
    </Stack>
  );
}

export default CreditCard;
